import { render, staticRenderFns } from "./InstructorResult.vue?vue&type=template&id=a983a1b8"
import script from "./InstructorResult.vue?vue&type=script&lang=js"
export * from "./InstructorResult.vue?vue&type=script&lang=js"
import style0 from "./InstructorResult.vue?vue&type=style&index=0&id=a983a1b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports